import { render, staticRenderFns } from "./MainHero.vue?vue&type=template&id=3b872e4e&scoped=true&"
import script from "./MainHero.vue?vue&type=script&lang=js&"
export * from "./MainHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b872e4e",
  null
  
)

export default component.exports